export const getEditorRoot = () =>
  document.getElementById('VisualEditorEditMode');